/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useState } from "react";
import { Container, Col, Row, Button } from "react-bootstrap";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";

import SunWestLogo from "../images/SunWest-Logo.png";
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu";
import PhoneIcon from "../images/phone_icon.svg";

import GallerySection from "./GallerySection";
import parse from "html-react-parser";

export default function Header({wholesaleurlData, sunwestLink}) {
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <Navbar
        collapseOnSelect
        className="px-2 px-md-3 px-lg-5 fixed-top marginBottom-navbar"
        bg="light"
        expand="lg"
      >
        <Navbar.Brand xl={4} lg={12} className="d-flex">
          <a href="https://www.swmc.com/">
            <img
              src={SunWestLogo}
              alt="Sun West logo"
              className="App-logo ml-0"
              width="300px"
              height="65px"
            />
          </a>
          <UserWayAccessibilityMenu color="black" width={40} height={40} />
        </Navbar.Brand>
        <Navbar className="justify-content-end" id="basic-navbar-nav">
          <Nav>
            <Container xl={10} lg={12} className="header-buttons-col">
              <Row className="header-button-row">
                <Col className="nav-item" md={3} sm={6} xs={12}>
                  <a
                    href="tel:+15166047454"
                    className="nav-bar-a"
                    style={{ color: "white" }}
                  >
                    <div className="button-div-new">
                      <span>
                        <img
                          className="phoneIcon"
                          src={PhoneIcon}
                          alt="Phone icon"
                          width="12px"
                          height="15px"
                        />
                        &nbsp; (516) 604-7454
                      </span>
                    </div>
                  </a>
                </Col>
              </Row>
            </Container>
          </Nav>
        </Navbar>
      </Navbar>

      <Container fluid>
        <Row className="winBoxTopmargin">
          <div className="otherbuttons">
            <div
              onClick={() => {
                let scrollToTable = document.getElementById("rateTable");
                scrollToTable.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
              className="button-div-new mt-3"
            >
              See Our Rates
            </div>

            <div className="mt-3">
              <AnchorLink
                href="#applyNowForm"
                className="nav-bar-a"
                style={{ color: "white" }}
              >
                <div className="button-div-new">Connect With Us</div>
              </AnchorLink>
            </div>
            <div className="mt-3">
              <a
                href={wholesaleurlData}
                className="nav-bar-a"
                target="_blank"
                style={{ color: "white" }}
                rel="noreferrer"
              >
                <div className="button-div-new">View Product Guidelines</div>
              </a>
            </div>
          </div>
        </Row>

        <div className="winHyperLinkBox pt-3 mb-3">
          {/* <a href='https://www.sunwestpartners.com/win' target='_blank' rel='noreferrer'> */}
          <Button variant="primary" className="winHyperLinkContainer">
            <h5 className="winHyperLink">
              Want to learn more about joining our team, call is confidential.
            </h5>
            {/* <h5 className='winHyperLink'>
                            Click here to learn more
                        </h5> */}
          </Button>
          {/* </a> */}
        </div>
        <Row
          style={{
            margin: "0",
            padding: "0",
          }}
        ></Row>
        {/* <div > */}
        <Row
          className="banner-top align-items-center"
          onClick={() => setOpen(true)}
        >
          <Col lg={6} md={7} sm={12} className="mb-4">
            <p>
              <div className="video-heading-line">
                Preferred Originator Partner
              </div>
              <div className="video-heading-line2">
                {" "}
                <span>Stop losing your loans to online retailers</span>
                <span>
                  Earn <b>300</b> Basis Points or more
                </span>
                <span>at {sunwestLink ? parse(sunwestLink) : 'Sun West'}'s Amazing Wholesale Rates</span>{" "}
              </div>
            </p>
            {/* <div className="side-image-container"> */}
            <img
              className="side-image img-fluid"
              src="https://resources.swmc.com/images/8-am-and-condition-review.webp"
              alt="8 AM Approval and 40 minutes condition review"
              width="160px"
              height="50px"
            />
          </Col>
          <Col lg={6} md={5} sm={12} className="text-center">
            {/* <iframe 
            className="youtube-Playlist"
            src="https://www.youtube.com/embed/videoseries?list=PL7eTBtWhXVyRrhRMekn2tECWGLt5t4o53"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen={true}
          ></iframe> */}
            <GallerySection />
          </Col>
        </Row>
      </Container>
    </>
  );
}
